import { useEffect } from 'react';
import { KeyIcon } from '@heroicons/react/24/outline';
import { authApi } from '../services/api';

export default function Logout() {
  useEffect(() => {
    // Redirect to logout URL immediately
    const logoutUrl = authApi.getLogoutUrl();
    window.location.href = logoutUrl;
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-secondary-50">
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-primary-600 rounded-xl flex items-center justify-center">
            <KeyIcon className="w-10 h-10 text-white" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-secondary-900 mb-2">Signing out...</h2>
        <p className="text-secondary-600">Please wait while we sign you out.</p>
        <div className="mt-6">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto"></div>
        </div>
      </div>
    </div>
  );
}
